import { memo } from "react";
import { Skeleton } from "@/app/components/shadcn/skeleton";
import { cn } from "@/app/utils/cn";

interface ProductCardSkeletonProps {
  size?: "default" | "sm";
}

const ProductCardSkeleton = ({
  size = "default",
}: ProductCardSkeletonProps) => {
  return (
    <div className="relative w-full flex flex-col h-full bg-white border border-gray-200 rounded-lg">
      <Skeleton
        className={cn(
          "shrink-0 rounded-t-lg w-full",
          size === "sm" ? "aspect-[3/4]" : "aspect-[2/3]",
        )}
      />

      <div className="p-1 sm:p-2 flex flex-col flex-1 space-y-2">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3.5 w-full" />
        <Skeleton className="h-3 w-3/4" />

        <div className="flex items-center gap-1.5 mt-1">
          <Skeleton className="h-3 w-3" />
          <Skeleton className="h-3 w-10" />
        </div>

        <div className="flex items-center gap-2 mt-auto pt-1">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-3.5 w-12" />
        </div>
      </div>
    </div>
  );
};

export default memo(ProductCardSkeleton);
